import { render, staticRenderFns } from "./ControversyErrorBox.vue?vue&type=template&id=12231c70&scoped=true"
import script from "./ControversyErrorBox.vue?vue&type=script&lang=js"
export * from "./ControversyErrorBox.vue?vue&type=script&lang=js"
import style0 from "./ControversyErrorBox.vue?vue&type=style&index=0&id=12231c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12231c70",
  null
  
)

export default component.exports